import { getApiUrl } from "./tcApiUrl";
export function getImportsComplianceURL() {
  const classifyurl = `${getApiUrl("importCompliance")}`;
  return classifyurl;
}

export const getImportsComplianceURLValue = () => {
  return getImportsComplianceURL();
};
